import { useEffect, useState, useContext } from "react";
import useFetch from "../hooks/useFetch";
import { Map, useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import Chart from "react-apexcharts";

import SimulationContext from "../contexts/Simulation";
import ProductSet from "./components/result/ProductSet";

//import productSets from "./components/result/DummyProducts";
import CtaReceiveQuotation from "./components/result/CtaReceiveQuotation";
import Popup from "./components/result/Popup";

import { ReactComponent as IconObjectifBaisse } from "../img/icons/objectifs/baisse.svg";
import { ReactComponent as IconObjectifAutonomie } from "../img/icons/objectifs/autonomie.svg";
import { ReactComponent as IconObjectifValorisation } from "../img/icons/objectifs/valorisation.svg";
import { ReactComponent as IconObjectifEcologie } from "../img/icons/objectifs/ecologie.svg";
//import { ReactComponent as IconEdit } from "../img/icons/edit.svg";
import { ReactComponent as IconPlus } from "../img/icons/plus.svg";
import { ReactComponent as IconMinus } from "../img/icons/minus.svg";
import { ReactComponent as LogoQualiPV } from "../img/logo/qualipv.svg";
import { ReactComponent as LogoQualitENR } from "../img/logo/qualitenr.svg";
import { ReactComponent as LogoRGE } from "../img/logo/rge.svg";

import ImgEcoIllustration from "../img/eco_illustration.png";
import ImgPhotoDevis1 from "../img/photos/photo2.png";
import ImgPhotoDevis2 from "../img/photos/photo3.png";
import ImgPushCouverture from "../img/push_couverture.png";
import ImgPhotosEtude from "../img/photos/photos45.png";
import { Link, useParams } from "react-router-dom";
import TextReassu from "../components/TextReassu";


const Tab = ({ children, IconBefore, selected, setSelected, className }) => {
  return (
    <div className={'tab ' + (className ?? '') + (selected ? ' active' : '')} onClick={ setSelected }>
      { IconBefore && <IconBefore className="icon-before"/> }
      { children }
    </div>
  )
}

const ResultStep = () => {
  const [simParams] = useContext(SimulationContext);
  const routeParams = useParams();
  const isResultRecord = !!routeParams.ruid;
  const [popupOpen, setPopupOpen] = useState(/*!(process.env?.NODE_ENV === 'development') &&*/ !simParams.contact && !isResultRecord);
  const [hasPricing] = useState(false);
  const [selectedProductSet, setSelectedProductSet] = useState(null);
  const [productSets, setProductSets] = useState(null);
  const [simDatas, setSimDatas] = useState(null);
  const [derivedDatas, setDerivedDatas] = useState(null);
  const [benefitLabels, setBenefitLabels] = useState([]);
  const [contactId, setContactId] = useState(null);
  const [opportunityId, setOpportunityId] = useState(null);
  const map = useMap();
  const mapsLib = useMapsLibrary('maps');
  const [loading, setLoading] = useState(false);
  const [doFetchSimResults, responseSimResults] = useFetch(
    isResultRecord ?
    `${process.env.REACT_APP_SIM_API_URL}/finsim/${routeParams.ruid}` :
    `${process.env.REACT_APP_SIM_API_URL}/finsim`
  );
  const [doFetchProducts, responseProducts] = useFetch(
    `${process.env.REACT_APP_SIM_API_URL}/productsets`
  );
  const numberFormatter = Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });
  //const numberDecimalFormatter = Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 });

  const donut_options = {
    colors: ['#193F71', '#5FA0F5', '#2A9FA5'],
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              show: true,
              showAlways: true,
              label: '/mois',
              fontFamily: 'poppins',
              color: '#000000',
              formatter: function (w) {
                return w.globals.seriesTotals.slice(0, 2).reduce((a, b) => {
                  return a + b
                }, 0) + ' €';
              }
            }
          }
        },
        expandOnClick: false
      },
    },
    legend: {
      show: false
    },
    chart: {
      animations: {
        enabled: true,
        dynamicAnimation: {
          enabled: true
        }
      }
    },
    labels: ['Facture d\'électricité', 'Abonnement d\'électricité'],
    yaxis: {
      labels: {
        formatter: (v) => { return v + ' €'; }
      }
    },
    dataLabels: {
      enabled: false
    },
    states: {
      hover: { filter: { type: 'none' } },
      active: { filter: { type: 'none' } },
    },
  };

  const objectifs = [
    {
      label: 'Augmenter la valeur de mon bien',
      icon: IconObjectifValorisation,
      key: 'valorisation'
    },
    {
      label: 'Baisser mes factures d\'électricité',
      icon: IconObjectifBaisse,
      key: 'economies'
    },
    {
      label: 'Faire un geste pour la planète',
      icon: IconObjectifEcologie,
      key: 'ecologie'
    },
    {
      label: 'Devenir autonome en énergie',
      icon: IconObjectifAutonomie,
      key: 'autonomie'
    },
  ];

  const changeProductSet = (index) => {
    setLoading(true);
    setSelectedProductSet(index);
  };

  useEffect(() => {
    window.scrollTo(0,0);
  }, []);

  useEffect(() => {
    if (selectedProductSet === null)
    {
      var obj = 0;
      if (simParams.infos)
        objectifs.forEach((o, i) => { if (o.key === simParams.infos.objectif) obj = i; });

      changeProductSet(obj);      
    }else{
      if (!isResultRecord)
      {
        const productsRequestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Auth-Token': process.env.REACT_APP_SIM_API_KEY
          },
          body: JSON.stringify({
            'consumption_amount': simParams.infos.conso.consumption_monthly_euros ?? simParams.infos.conso.consumption_yearly_kw,
            'consumption_type': simParams.infos.conso.consumption_monthly_euros ? 'euros_monthly' : 'kw_yearly',
            'infos_type': simParams.infos.type,
            'infos_inclinaison': simParams.infos.inclinaison,
            'infos_elec_phase': simParams.infos.elec_phase,
            'subscription_power': simParams.infos.puissance
          }),
        };
        doFetchProducts(productsRequestOptions);
      }

      const simRequestOptions = {
        method: isResultRecord ? 'GET' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Auth-Token': process.env.REACT_APP_SIM_API_KEY
        },
        body: isResultRecord ? null : JSON.stringify({
          'latitude': simParams.adjustedLocation.lat,
          'longitude': simParams.adjustedLocation.lng,
          'consumption_amount': simParams.infos.conso.consumption_monthly_euros ?? simParams.infos.conso.consumption_yearly_kw,
          'consumption_type': simParams.infos.conso.consumption_monthly_euros ? 'euros_monthly' : 'kw_yearly',
          'infos_type': simParams.infos.type,
          'infos_inclinaison': simParams.infos.inclinaison,
          'infos_elec_phase': simParams.infos.elec_phase,
          'infos_objectif': objectifs[selectedProductSet].key,
          'azimuth': simParams.orientation,
          'inclination': simParams.infos.inclinaison,
          'subscription_power': simParams.infos.puissance,
          'infos_equipments': simParams.infos.equipements.concat(simParams.infos.equipements_futur),
          'surface_area': simParams.surface.area,
          'surface_drawing': simParams.surface.drawing
        }),
      };
      doFetchSimResults(simRequestOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProductSet]);

  useEffect(() => {
    if (responseProducts)
      setProductSets(responseProducts.map(r => { return {...r, is_optionnal: !r.qty === 0}}));
  }, [responseProducts]);

  useEffect(() => {
    if (responseSimResults)
      setSimDatas(responseSimResults);
  }, [responseSimResults]);

  useEffect(() => {
    if (simDatas)
    {
      const monthly_savings = (simDatas.yearly_data[0][0] + simDatas.yearly_data[0][1]) / 12;
      var monthly_bill; // including subscription
      if (isResultRecord)
        monthly_bill = (simDatas.inputs.consumption_type === 'euros_monthly') ? 
                       parseFloat(simDatas.inputs.consumption_amount) :
                       ((parseFloat(simDatas.inputs.consumption_amount) * simDatas.kw_buy_price / 12) + simDatas.monthly_subscription);
      else
        monthly_bill = simParams.infos.conso.consumption_monthly_euros ??
            ((simParams.infos.conso.consumption_yearly_kw * simDatas.kw_buy_price / 12) + simDatas.monthly_subscription);
      var datas_savings = [];
      var datas_resell = [];
      var datas_self = [];
      simDatas.yearly_data.forEach((d, i) => {
        datas_savings.push(d[0]);
        datas_resell.push(d[1]);
        datas_self.push(d[0] - d[1]);
      });
      setDerivedDatas({
        monthly_savings: monthly_savings,
        monthly_bill: monthly_bill,
        chart_datas: {
          savings: datas_savings,
          resell: datas_resell,
          self: datas_self,
          before: [Math.max(0, Math.round(monthly_bill - simDatas.monthly_subscription)), Math.round(simDatas.monthly_subscription)],
          after: [Math.max(0, Math.round(monthly_bill - simDatas.monthly_subscription - monthly_savings)), Math.round(simDatas.monthly_subscription), Math.round(monthly_savings)]
        }
      });
      var labels = [];
      objectifs.forEach((objectif) => {
        switch (objectif.key)
        {
          case 'economies':
            labels.push({
              main: `Économie : ${numberFormatter.format(monthly_savings)} €/mois`,
              sub: '*Estimation moyenne basée selon votre consommation et les conditions locales (ensoleillement, orientation, autoconsommation, etc.)'
            });
            break;
          case 'ecologie':
            labels.push({
              main: `Impact : ${numberFormatter.format(simDatas.avg_yearly_energy * 0.03)} kg/an de CO₂ évités`,
              sub: '*Estimation calculée sur la base du mix énergétique moyen en France (environ 30 g CO₂/kWh évité) et d’une production annuelle estimée de {{prod}} kWh. Cette valeur peut varier selon votre région et votre consommation effective.'.replace('{{prod}}', simDatas.avg_yearly_energy)
            });
            break;
          case 'valorisation':
            labels.push({
              main: `Revalorisation : 3 à 8 %`,
              sub: '*selon plusieurs études immobilières et énergétiques (notamment en France, aux États-Unis et au Royaume-Uni)'
            });
            break;
          case 'autonomie':
            labels.push({
              main: `Autonomie : ${numberFormatter.format(simDatas.self_consumption_ratio * 100)}% de vos besoins`,
              sub: '*Cette estimation est basée sur notre expérience client et des profils de consommation type. Elle peut varier selon votre situation réelle.'
            });
            break;
          default:
        }
      });
      setBenefitLabels(labels);

      if (isResultRecord)
      {
        var obj = 0;
        var ps = [];
        objectifs.forEach((o, i) => { 
          if (o.key === simDatas.inputs.infos_objectif) {
            obj = i; 
            ps.push(simDatas.product_set);
          }else
            ps.push(null);
        });
        setProductSets(ps);
        changeProductSet(obj);
      }
    }
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [simDatas]);

  useEffect(() => {
    if (!mapsLib || !map) return;

    var surface_drawing = new mapsLib.Polygon({
      paths: (isResultRecord && simDatas) ? simDatas.inputs.surface_drawing : simParams.surface.drawing,
      strokeColor: '#FFA531',
      fillColor: '#FFD400'
    });
    surface_drawing.setMap(map);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapsLib, map, simParams.surface.drawing, simDatas?.inputs?.surface_drawing]);

  const toggleOption = (index) => {
    var selection = productSets[selectedProductSet].assigned_products.map(x => x.qty);
    selection[index] = (parseInt(selection[index]) ? 0 : 1).toString();
    for (var i = 0; i < productSets.length; i++)
    {
      if (JSON.stringify(productSets[i].assigned_products.map(x => x.qty)) === JSON.stringify(selection))
      {
        changeProductSet(i);
        break;
      }
    }
  };

  return (
    <>
      { popupOpen && <Popup setOpen={setPopupOpen} setContactId={setContactId} setOpportunityId={setOpportunityId}></Popup> }
      <div className="objectifs">
        {
          objectifs.map((obj, index) => {
            const selected = index === selectedProductSet;
            return (
              <Tab 
                IconBefore={obj.icon} 
                selected={selected} 
                setSelected={ () => { if (!isResultRecord) changeProductSet(index); } } 
                className={(isResultRecord && !selected) ? 'disabled' : null}
                key={obj.label}
              >
                { obj.label }
              </Tab>
            );
          })
        }
      </div>
      <div className="resultwrapper">
        <div className="left" id="resultats">
          <div className="card installation">
            <div className="title">☀️ Merci {simParams.contact?.firstname} ! voici votre installation</div>
            <div className="wrapper">
              <div className="recap">
                <div className="mapwrap">
                  <div className="surface_selection" style={{left: '50%', top: '80%'}}>Votre&nbsp;surface&nbsp;:<br/><span>{ (isResultRecord && simDatas) ? simDatas.inputs.surface_area :  simParams.surface.area } m<sup>2</sup></span></div>
                  <Map
                    mapTypeId={'satellite'}
                    center={(isResultRecord && simDatas) ? {lat: simDatas.inputs.latitude, lng: simDatas.inputs.longitude} : simParams.adjustedLocation}
                    zoom={21}
                    tilt={0}
                    gestureHandling={'none'}
                    disableDefaultUI={true}
                    controlled={true}>
                  </Map>
                </div>
                { !!simParams.location.formatted &&
                <div className="addr">
                  <b>{ simParams.contact?.firstname } { simParams.contact?.lastname }</b><br/>
                  { simParams.location.formatted.split(', ')[0] ?? '' }<br/>
                  { simParams.location.formatted.split(', ')[1] ?? '' }
                </div>
                }
              </div>
              { simDatas && derivedDatas &&
              <div className={'details loader' + (loading ? ' loading' : '')}>
                <div className="products">
                  {
                    productSets && (selectedProductSet !== null) && productSets[selectedProductSet].assigned_products.map((p, index) => {
                      return (p.key_product &&
                        <div 
                          key={p.product.name}
                          className={'product' + (p.optionnal ? (p.qty > 0 ? ' enabled' : ' disabled') : '')}
                          onClick={() => { if (!isResultRecord) toggleOption(index); }}
                        >
                          { (p.qty > 0) && <div className="qty">x{p.qty}</div> }
                          { p.optionnal && ((p.qty > 0) ? <IconMinus className="remove"/> : <IconPlus className="add"/>) }
                          {/* <IconEdit className="edit"/> */}
                          <div></div>
                          { p.product.photo_file && 
                          <img alt='' src={process.env.REACT_APP_SIM_IMG_URL + '/product_photos/' + p.product.photo_file}/> }
                          <span>{ p.product.name }</span>
                        </div>
                      )
                    })
                  }
                </div>
                <div className="kpis">
                  <div className="kpi">
                    <div></div>
                    <div className="number">{ simDatas.peak_power }<span className="unit">kWc</span></div>
                    <div className="sub">Puissance crête conseillée</div>
                  </div>
                  <div className="kpi">
                    <div></div>
                    <div className="number">{ numberFormatter.format(simDatas.avg_yearly_energy) }<span className="unit">kWh/an</span></div>
                    <div className="sub">Production annuelle estimée</div>
                  </div>
                  <div className="kpi">
                    <div></div>
                    <div className="number">{ numberFormatter.format(Math.max(0, derivedDatas.monthly_bill - derivedDatas.monthly_savings)) }<span className="unit">€/mois</span></div>
                    <div className="sub">Facture d'électricité estimée</div>
                  </div>
                </div>
                <div className="savings gradient">{ benefitLabels[selectedProductSet].main }<sup>*</sup></div>
                <div className="sub">{ benefitLabels[selectedProductSet].sub }</div>
              </div>
              }
            </div>
          </div>
          { simDatas && derivedDatas && <>
          <div className="card rentabilite">
            <div className="title">🎯 Votre rentabilité</div>
            <div className={'card inner donut-charts'}>
              <div className="donut">
                <div className="title">Avant</div>
                <Chart
                  options={donut_options}
                  series={derivedDatas.chart_datas.before}
                  type="donut"
                  width="270"
                  className={loading && 'dataloading'}
                />
              </div>
              <div className="donut">
                <div className="title">Après</div>
                <Chart
                  options={donut_options}
                  series={derivedDatas.chart_datas.after}
                  type="donut"
                  width="270"
                  className={loading && 'dataloading'}
                />
              </div>
              <div className={'legend loader' + (loading ? ' loading' : '')}>
                <ul>
                  <li>Facture d'électricité <small>(hors abonnement)</small> : { Math.max(0, Math.round(derivedDatas.monthly_bill - simDatas.monthly_subscription)) }&nbsp;€</li>
                  <li>Abonnement d'électricité : { Math.round(simDatas.monthly_subscription) }&nbsp;€</li>
                </ul>
              </div>
              <div className={'legend loader' + (loading ? ' loading' : '')}>
                <ul>
                  <li>Facture d'électricité <small>(hors abonnement)</small> : { Math.max(0, Math.round(derivedDatas.monthly_bill - simDatas.monthly_subscription - derivedDatas.monthly_savings)) } €</li>
                  <li>Abonnement d'électricité : { Math.round(simDatas.monthly_subscription) } €</li>
                  <li>Economies : { Math.round(derivedDatas.monthly_savings) } €</li>
                </ul>
              </div>
            </div>
            <div className={'roi loader' + (loading ? ' loading' : '')}>
              <div>Économies sur { simDatas.depreciation_period } ans <b>{ numberFormatter.format(simDatas.total_savings) } €</b></div>
              <div>Revente sur { simDatas.depreciation_period } ans <b>{ numberFormatter.format(simDatas.total_resell) } €</b></div>
              <div>{/* !!simDatas.roi_period && (simDatas.roi_period <= 15) && <div>Retour sur investissement <b>{ numberFormatter.format(simDatas.roi_period) } ans</b></div> */}</div>
            </div>
            <div className="card inner bar-chart">
              { derivedDatas && <Chart
                type="bar"
                options={{
                  xaxis: {
                    categories: (() => { 
                      var y = (new Date()).getFullYear();
                      var r = []; 
                      for (var i = y; i < y + simDatas.depreciation_period; i++) 
                        r.push(i); 
                      return r; 
                    })()
                  },
                  yaxis: {
                    decimalsInFloat: 0,
                    show: hasPricing
                  },
                  legend: {
                    markers: {
                      shape: 'circle',
                      size: 10,
                      offsetX: -5
                    },
                    fontFamily: 'poppins',
                    fontSize: 16,
                    itemMargin: {
                      horizontal: 16
                    }
                  },
                  chart: {
                    toolbar: {
                      show: false
                    },
                    animations: {
                      enabled: true,
                      dynamicAnimation: {
                        enabled: true
                      }
                    }
                  },
                  /*annotations: {
                    yaxis: [
                      {
                        y: simDatas.system_cost,
                        borderColor: '#FF0000',
                        borderWidth: (!!simDatas.roi_period && (simDatas.roi_period <= 15)) ? 2 : 0,
                        style: 'solid'
                        label: {
                          borderColor: '#00E396',
                          style: {
                            color: '#fff',
                            background: '#00E396'
                          },
                          text: 'Y-axis annotation on 8800'
                        }
                      }
                    ]
                  }*/
                }}
                series={[
                  {
                    name: "Economies",
                    data: derivedDatas.chart_datas.savings
                  },
                  {
                    name: "Revente",
                    data: derivedDatas.chart_datas.resell
                  },
                  {
                    name: "Autoconsommation",
                    data: derivedDatas.chart_datas.self
                  }
                ]}
              /> }
            </div>
            <div className="packs">
              { 
                productSets && productSets.map((set, index) => {
                  return (
                    set &&
                    <div key={set.name} className={'pack' + ((index === selectedProductSet) ? ' active' : '')} onClick={() => changeProductSet(index)}>
                      <div className="header" dangerouslySetInnerHTML={{__html: set.name.split(' ').map(e => `<span>${e}</span>`).join('<br/>')}}></div>
                      <ProductSet products={set} display_disabled={true} benefit={(index === selectedProductSet) && benefitLabels[index]} loading={loading} />
                    </div>
                  )
                })
              }
            </div>
          </div>
          <div className="card produits">
            <div className="title">👍 Nos recommandations produits</div>
            {
              (selectedProductSet != null) && productSets && productSets[selectedProductSet].assigned_products.map((p, index) => {
                return (p.qty && p.key_product &&
                  <div key={p.product.name} className="card inner border">
                    <div className="product_photo"><img alt='' src={process.env.REACT_APP_SIM_IMG_URL + '/product_photos/' + p.product.photo_file}/></div>
                    <div className="product_desc">
                      { p.product?.brand?.logo_file && 
                      <div className="logo" style={{backgroundImage: `url(${process.env.REACT_APP_SIM_IMG_URL}/brand_logos/${p.product.brand.logo_file})`}}></div> }
                      <div className="name">{ p.product.name }</div>
                      { p.product?.specifications && 
                      <div className="specs">
                        {
                          p.product.specifications.map((ps, index) => {
                            return (
                              <div key={ps.spec.name} className={'spec ' + (ps.spec.skey || '')}><label dangerouslySetInnerHTML={{__html: ps.spec.name}}></label>: {ps.value}</div>
                            );
                          })
                        }
                      </div> }
                      { p.product.brohure_file && 
                      <div className="download"><a href={p.product.brohure_file}>Télécharger la fiche technique</a></div> }
                    </div>
                  </div>
                );
              })
            }
          </div>
          <div className="card impact">
            <div className="title">🌱 Votre impact environnemental !</div>
            <div className="wrapper">
              <ul className="ecoleft">
                <li>
                  <div className="title">🌳 120 arbres plantés</div>
                  L’équivalent de 120 arbres plantés sur 15 ans... sans avoir à creuser un seul trou ni arroser une seule fois !
                </li>
                <li>
                  <div className="title">🛢️ 10 barils de pétrole économisés</div>
                  Moins de pétrole brûlé = plus d'air pur pour respirer à pleins poumons !
                </li>
                <li>
                  <div className="title">🚗 17 000 km en voiture évités</div>
                  L’équivalent de 17 000 km parcourus... soit 10 Paris-Lisbonne aller-retours sans jamais faire le plein !
                </li>
                <li>
                  <span>❗<b>A NOTER</b> : chaque chiffre est indépendant des autres !<br/>
                  Mais tous te rendent un peu plus écolo 😁</span>
                </li>
              </ul>
              <img alt='' className="ecoright" src={ImgEcoIllustration}/>
            </div>
          </div>
          <div className="card devis">
            <div className="title">😊 Votre projet</div><div className="subtitle">⚠️ Une visite technique sera nécéssaire pour vous proposer un devis sur-mesure</div>
            { productSets && (selectedProductSet !== null) && <ProductSet products={productSets[selectedProductSet]} display_desc={true} /> }
            { simDatas && 
            <div className="cta-receive">
              <div className="photos">
                <img alt='' src={ImgPhotoDevis1} width={79} height={78}/>
                <img alt='' src={ImgPhotoDevis2} width={78} height={78}/>
              </div>
              <div className="title">Votre étude est prête<br/>Nous aussi !</div>
              <CtaReceiveQuotation contactId={contactId} opportunityId={opportunityId} simId={simDatas.uid} isResultRecord={isResultRecord}/>
            </div>
            }
          </div> </>}
        </div>
        <div className="right">
          <div id="devis">
            { simDatas && 
            <div className="cta-receive">
              <div className="title">Passons<br/>aux choses<br/>sérieuses !</div>
              <img src={ImgPhotosEtude} alt="" className="photo"/>
              <div className="sub">👉 <b>Prochaine étape ?</b><br/>
              Un expert Artyseo vous recontactera pour affiner votre projet.</div>
              <CtaReceiveQuotation contactId={contactId} opportunityId={opportunityId} simId={simDatas.uid} isResultRecord={isResultRecord}/>
              <a href="tel:0241051088" class="tel">02 41 05 10 88<br/>
              Un expert se déplace en 48h</a>
            </div>
            }
          </div>
          <TextReassu/>
          <div className="logosquali">
            <LogoQualiPV/>
            <LogoQualitENR/>
            <LogoRGE/>
          </div>
          <div className="push">
            <Link to='/prestations/particuliers/couverture-toiture' target='_blank'>
              <img src={ImgPushCouverture} alt='/prestations/particuliers/couverture-toiture'/>
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}

export default ResultStep;